import { render, staticRenderFns } from "./DoctorNotesListView.vue?vue&type=template&id=2b7808be&scoped=true"
import script from "./DoctorNotesListView.vue?vue&type=script&lang=js"
export * from "./DoctorNotesListView.vue?vue&type=script&lang=js"
import style0 from "./DoctorNotesListView.vue?vue&type=style&index=0&id=2b7808be&prod&scoped=true&lang=css"
import style1 from "./DoctorNotesListView.vue?vue&type=style&index=1&id=2b7808be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7808be",
  null
  
)

export default component.exports